/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";

//components
import { Modal } from "@mui/material";
import FirstPage from "./first-page";
import SecondPage from "./countdown";
import ErrorPage from "../common/errorPage";
import SuccessPage from "../common/successPage";

import { apiCall, toggleLoading } from "store/actions";
import { FETCH_PAYMENT_LINK_DETAILS } from "graphql";
import { fetchBaseURL } from "utils";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    outline: "none",
    boxShadow: 24,
    p: 4,
};

export default function ({ loading }) {
    const dispatch = useDispatch();
    const { plinkId } = useParams();

    const [page, setPage] = useState(0);
    const [error, setError] = useState("");
    const [details, setDetails] = useState({
        plinkId: plinkId,
        walletAddress: "",
        amount: 0,
        merchant: "",
        paymentFor: "",
        currency: "",
        network: "",
        baseUrl: fetchBaseURL(plinkId, "plink_"),
    });

    useEffect(() => {
        fetchPlinkDetails();
    }, []);

    const fetchPlinkDetails = async () => {
        dispatch(toggleLoading(true));
        const response = await apiCall(details.baseUrl, FETCH_PAYMENT_LINK_DETAILS, { plinkId: plinkId });

        if (!response.status) {
            dispatch(toggleLoading(false));
            setError(response.data?.message ?? "Payment Link not working");
            return setPage(3);
        }

        const {
            data: { merchant_id, amount, payment_for, currency },
        } = response.data?.list_payment_link_details;

        setDetails({
            ...details,
            merchant: merchant_id?.name ?? "",
            amount: amount,
            paymentFor: payment_for,
            currency: currency,
        });
        dispatch(toggleLoading(false));
        return handlePage(1);
    };

    const handlePage = (data) => {
        setPage(data);
    };

    const handlePaymentDetails = (data) => {
        setDetails(data);
    };

    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <div className="flex content-center items-center justify-center h-full">
                    <div className="w-full lg:w-4/12 px-4">
                        <Modal open={!loading}>
                            <div
                                style={style}
                                className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
                            >
                                {page === 1 ? (
                                    <FirstPage
                                        dispatch={dispatch}
                                        handlePage={handlePage}
                                        handlePaymentDetails={handlePaymentDetails}
                                        paymentDetails={details}
                                    />
                                ) : page === 2 ? (
                                    <SecondPage handlePage={handlePage} paymentDetails={details} />
                                ) : page === 3 ? (
                                    <ErrorPage error={error} />
                                ) : page === 4 ? (
                                    <SuccessPage />
                                ) : null}
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
}
